import { Box, Skeleton, Tooltip } from '@hopskipdrive/react-components';
import HandshakeIcon from '@mui/icons-material/Handshake';

import { LabelChip } from '../../../../shared/components/LabelChip';
import { colorPalette, colorTokens } from '../../../../shared/components/variables';

export const RideRequiredServices = ({ requiredServices, isFetching }) => {
  if (isFetching) {
    return (
      <Box display="flex" flexDirection="row" gap="6px" flexWrap="wrap">
        <Skeleton width={76} height={35} />
        <Skeleton width={64} height={35} />
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="row" gap="6px" flexWrap="wrap">
      {requiredServices?.map((service) => (
        <Tooltip
          key={service.code}
          title={service.description}
          placement="top"
          componentsProps={{
            tooltip: {
              sx: {
                maxWidth: 'none',
              },
            },
          }}
        >
          <div>
            <LabelChip
              label={service.code}
              isFetching={false}
              bgColor={colorPalette.plum950}
              textColor={colorTokens.plum.dark}
              border={`1px solid ${colorTokens.plum.outlineBorder}`}
              icon={<HandshakeIcon style={{ color: colorTokens.plum.dark }} />}
            />
          </div>
        </Tooltip>
      ))}
    </Box>
  );
};
